import { createSlice } from "@reduxjs/toolkit";
import { getUserAccess } from "../../actions/users/userAccessAction";
import { Access } from "../../../types/users/userAccess";
import { ROLES } from "../../../config/roles";
type InitialState = {
  isLoading: boolean;
  isError: boolean;
  data: Access;
};
const initialState: InitialState = {
  isLoading: false,
  isError: false,
  data: {
    gpid: "",
    email: "",
    first_name: "",
    last_name: "",
    userRoles: [],
    userSectors: [],
    appFeedback: [],
    userAccess: {
      query_chatbot: "",
      closeout_form: "",
      upload_engagement_docs: "",
      view_self_closeout_details: "",
      access_snow_intake_request_form: "",
      view_snow_intake_ritms: "",
      submit_closeout_request_ritms: "",
      manage_roles_and_access: "",
      view_closeout_forms: "",
      view_internal_docs_for_chatbot_response: "",
      download_internal_docs_for_chatbot_response: "",
      view_confidential_docs_for_chatbot_response: "",
      download_confidential_docs_for_chatbot_response: "",
      add_users_with_mirror_rights: "",
      view_all_internal_confidential_docs: "",
      download_all_internal_confidential_docs: "",
      view_all_restricted_documents: "",
      delete_uploaded_documents: "",
      change_document_classification: "",
    },
    hasAdmin: false,
    gpLeadSectors: [],
    isSurveyFormSubmitted: true,
    reschedule_interval: 0,
  },
};

const userAccessReducer = createSlice({
  name: "userAccess",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserAccess.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(getUserAccess.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        // check if user has admin role
        const hasAdminRole = action.payload.userRoles.find(
          (role) => role.role.name === ROLES.admin.displayText
        );

        const gpLeadSectors = action.payload.userSectors.map(
          (sector) => sector.sectors.name
        );
        localStorage.setItem(
          "isSurveySubmitted",
          String(action.payload.isSurveyFormSubmitted)
        );
        state.data = action.payload;
        state.data.hasAdmin = Boolean(hasAdminRole);
        state.data.gpLeadSectors = gpLeadSectors;  
      })
      .addCase(getUserAccess.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});

export default userAccessReducer.reducer;
